import { render, staticRenderFns } from "./minhaConta.vue?vue&type=template&id=206a6572&scoped=true&"
import script from "./minhaConta.vue?vue&type=script&lang=js&"
export * from "./minhaConta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206a6572",
  null
  
)

export default component.exports